import styled from '@emotion/styled';
import { Link } from '@sunrun/component-library';

export default styled(Link)`
  font-family: Roobert;
  font-size: 14px;
  font-weight: 750;
  cursor: pointer;
`;
